import { PhoneIncoming, PhoneOutgoing, Voicemail, Warning } from '@phosphor-icons/react'

export const audioMessageConfig = (size) => ({
  'Answered Outbound': {
    icon: <PhoneOutgoing size={size} weight="fill" />,
    className: 'audio-message__incoming',
  },
  'Answered Inbound': {
    icon: <PhoneIncoming size={size} weight="fill" />,
    className: 'audio-message__incoming',
  },
  'Unanswered Outbound': {
    icon: <PhoneOutgoing size={size} weight="fill" />,
    className: 'audio-message__outgoing',
  },
  'Unanswered Inbound': {
    icon: <PhoneIncoming size={size} weight="fill" />,
    className: 'audio-message__outgoing',
  },
  Voicemail: {
    icon: <Voicemail size={size} weight="fill" />,
    className: 'audio-message__voice',
  },
  'Emergency Voicemail': {
    icon: <Warning size={size} weight="fill" />,
    className: 'audio-message__emergency-voice',
  },
})
